import { RequestService } from '../../../../../common/services/RequestService';
import { API } from '../../../../../common/api/constants';

export const avatarUploadRequest = payload => {
  return RequestService.post(`${API}/utility/image/upload/user`, payload);
};
